// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"_450b46e9","checkMarkIcon":"f97c6116","fileIcon":"_7ec1ed32","folderIcon":"_1528cda6","stopIcon":"_06a7f9f6","warningIcon":"_58aed5d0"};